<template>
    <div :class="['d-flex', 'align-items-center', computedClass]" class="parent">
        <div class="meter bg-light">
            <span :class="['d-flex', percentageBg]" :style="{ width: availabilityPercentage + '%' }"></span>
        </div>

        <strong :class="['text-right', 'flex-all', percentageColor]" v-if="showText">{{ availability }}</strong>
    </div>
</template>

<script>
    export default {
        props: {
            event: Object,
            showText: Boolean
        },
        computed: {
            percentageBg: function() {
                return this.danger ? 'bg-color-6' : 'bg-color-1';
            },
            percentageColor: function() {
                return this.danger ? 'color-6' : 'dark';
            },
            computedClass: function() {
                return this.showText ? 'spaced' : '';
            },
            danger: function() {
                return (this.availabilityPercentage >= 90);
            },
            availability: function() {
                return this.event.quantityAvailable + '/' + this.event.maximumLotation;
            },
            availabilityPercentage: function() {
                var availability = this.event.quantityAvailable / this.event.maximumLotation;

                return availability !== undefined ? (1 - availability) * 100 : 0;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';
    .parent{
        min-height: 2px;

        .meter {
            flex: 4;
            height: 4px;
            border-radius: 2px;
            min-height: 2px;

            > span {
                width: 0%;
                height: 4px;
                border-radius: 2px;
                min-height: 2px;
            }
        }

        .event {
            min-height: 2px;
            width: 100%;

            .spaced {
                margin: 1rem 0.5rem 0 1.75rem;
            }


        }
    }
</style>



// WEBPACK FOOTER //
// EventMeter.vue?605af878